export const SET_ROOMS = 'availability/SET_ROOMS';
export const SET_ROOMS_CLEANUP = 'availability/SET_CLEAR_ROOMS';
export const SET_FULL_CLEANUP = 'availability/SET_FULL_CLEANUP';
